import type { ActivityItem } from '../../activity-journal';

export function compareItemsNewestFirst(
    left: ActivityItem,
    right: ActivityItem
): number {
    return Date.parse(right.updatedAtUtc) - Date.parse(left.updatedAtUtc);
}

export function compareItemsOldestFirst(
    left: ActivityItem,
    right: ActivityItem
): number {
    return Date.parse(left.createdAtUtc) - Date.parse(right.createdAtUtc);
}
